import { AUTH_PAGES, pageModules } from '@pmai/contracts';
import { createBrowserRouter, type RouteObject } from 'react-router';
import { AcceptInvitationPage } from '../features/auth/accept-invitation-page';
import { AuthLayout } from '../features/auth/auth-layout';
import { ForgotPasswordPage } from '../features/auth/forgot-password-page';
import { LoginPage } from '../features/auth/login-page';
import { RegisterPage } from '../features/auth/register-page';
import { ResetPasswordPage } from '../features/auth/reset-password-page';
import { VerifyEmailPage } from '../features/auth/verify-email-page';
import { NotFoundPage, PlannedPage } from '../shared/system-pages';
import { AppLayout } from './app-layout';
import { ModulePage } from './module-page';
import { PAGES, SUB_PAGES } from './pages';

const relative = (path: string) => path.replace(/^\//, '');

/** Every page route comes from the module registry — no hand-written route list (ADR 0010). */
function moduleRoutes(): RouteObject[] {
  return pageModules().map((module) => {
    const Page = PAGES[module.key as keyof typeof PAGES];
    const page = <ModulePage module={module}>{Page ? <Page /> : <PlannedPage module={module} />}</ModulePage>;
    if (module.path === '/') return { index: true, element: page };
    const children = (SUB_PAGES[module.key as keyof typeof SUB_PAGES] ?? []).map(
      ({ Component, ...rest }) => ({
        ...rest,
        element: (
          <ModulePage module={module}>
            <Component />
          </ModulePage>
        ),
      }),
    );
    return { path: relative(module.path), children: [{ index: true, element: page }, ...children] };
  });
}

export const authRoutes: RouteObject[] = [
  { path: relative(AUTH_PAGES.login), element: <LoginPage /> },
  { path: relative(AUTH_PAGES.register), element: <RegisterPage /> },
  { path: relative(AUTH_PAGES.verifyEmail), element: <VerifyEmailPage /> },
  { path: relative(AUTH_PAGES.forgotPassword), element: <ForgotPasswordPage /> },
  { path: relative(AUTH_PAGES.resetPassword), element: <ResetPasswordPage /> },
  { path: relative(AUTH_PAGES.acceptInvitation), element: <AcceptInvitationPage /> },
];

export function createRouter() {
  return createBrowserRouter([
    { element: <AuthLayout />, children: authRoutes },
    {
      path: '/',
      element: <AppLayout />,
      children: [...moduleRoutes(), { path: '*', element: <NotFoundPage /> }],
    },
  ]);
}
